// eslint-disable-next-line no-process-env
const version = process.env.VERSION;

module.exports = {
  version,
  storageKeys: {
    store: `AuthNZUIStore_${version}`,
    requests: `AuthNZUIRequests_${version}`,
  },
  api: {
    url: `/api/${version}`,
    endpoints: {
      auth: {
        login: 'auth/login',
        remember: 'auth/remember-password',
        reset: 'auth/reset-password',
        referrer: 'auth/referrer/:code/:ref',
      },
      user: {
        update: 'user/update',
      },
      users: {
        new: 'users/new',
        reactivate: 'users/reactivate',
        import: 'users/import',
        edit: 'users/edit/:userId',
        delete: 'users/delete/:userId',
        removeAccess: 'users/remove-access/:userId',
        byId: 'users/:userId',
        list: {
          path: 'users/list/:page',
          query: {
            count: 20,
            search: null,
          },
        },
        permissions: {
          brand: 'users/:userId/permissions/brand/:brandId',
        },
        roles: 'users/:userId/roles/brand/:brandId/:scopeId',
        brandAdminSettings: 'users/:userId/brand-admin-settings',
      },
      brands: {
        byId: 'brands/:brandId',
        permissions: 'brands/permissions',
        list: {
          path: 'brands/list/:page',
          query: {
            count: 20,
            search: null,
          },
        },
        adminSettings: 'brands/:brandId/admin-settings',
      },
      permissions: {
        appRoles: 'permissions/app-roles',
        all: 'permissions/all',
        roles: 'permissions/scopes/:scopeId/roles',
        scopes: 'permissions/scopes',
        scope: 'permissions/scopes/:scopeId',
        role: 'permissions/roles/:roleId',
        save: {
          brands: 'permissions/save/brands',
          app: 'permissions/save/app/:userId/:roleId',
        },
        revoke: {
          brands: 'permissions/revoke/brands',
        },
      },
      activities: {
        search: 'activities/search',
        download: 'activities/download/:token/:userId',
      },
    },
  },
  privacyPolicyURL: 'https://www.socialnative.com/privacy-policy/',
};
